import { useEffect, useState } from "react";
import { sharedData } from "./utils/sharedData";
import GameContainer from "./containers/GameContainer";
import "./App.css";

const preventDefault = (e) => e.preventDefault();

const App = () => {
	const [firstReword, setFirstReword] = useState(false);

	useEffect(() => {
		window.addEventListener("contextmenu", preventDefault);

		const script = document.createElement("script");
		script.src = "/sdk.js";
		script.async = true;
		script.onload = () => {
			if (window.YaGames) {
				window.YaGames.init()
					.then((sdk) => {
						sdk.adv.showFullscreenAdv({
							callbacks: {
								onOpen: () => {},
								onClose: () => {
									setFirstReword(true);
									sharedData.lastRewordTime = Date.now();
								},
								onError: () => {
									setFirstReword(true);
								},
							},
						});

						window.sdk = sdk;
						sharedData.lang = sdk.environment.i18n?.lang || "ru";

						console.log("YaGames SDK initialized");
					})
					.catch((error) => {
						console.error("Failed to initialize YaGames SDK", error);
						setFirstReword(true);
					});
			} else {
				console.error("YaGames SDK not found");
				setFirstReword(true);
			}
		};
		document.body.append(script);

		return () => {
			window.removeEventListener("contextmenu", preventDefault);
		};
	}, []);

	useEffect(() => {
		if (firstReword && window.sdk) {
			setTimeout(() => {
				window.sdk.features.LoadingAPI?.ready();
			}, 200);
		}
	}, [firstReword]);

	return firstReword && <GameContainer />;
};

export default App;
